/* istanbul ignore file */

import React, { memo } from 'react';

import { useSelector } from '@xstate/react';

import { type LocationSearchService } from '../../machine';
import { LocationSearchDeliveryResult, LocationSearchLocationsResults } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const LocationSearchResults = memo((props: LocationSearchResultsProps) => {
  const {
    locationSearchActorRef,
    interactedLocationRestaurantSlug,
    interactedLocationDeliveryAddressId,
    withSafeAreaInsets,
    onExpandedChange,
  } = props;

  const locationSearchType = useSelector(
    locationSearchActorRef,
    (snapshot) => snapshot.context.locationSearchType,
  );

  if (locationSearchType === 'delivery') {
    return (
      <LocationSearchDeliveryResult
        locationSearchActorRef={locationSearchActorRef}
        interactedLocationRestaurantSlug={interactedLocationRestaurantSlug}
        interactedLocationDeliveryAddressId={interactedLocationDeliveryAddressId}
        withSafeAreaInsets={withSafeAreaInsets}
        onExpandedChange={onExpandedChange}
      />
    );
  }

  return (
    <LocationSearchLocationsResults
      locationSearchActorRef={locationSearchActorRef}
      interactedLocationRestaurantSlug={interactedLocationRestaurantSlug}
      withSafeAreaInsets={withSafeAreaInsets}
      onExpandedChange={onExpandedChange}
    />
  );
});

// ─── Types ───────────────────────────────────────────────────────────────────

type LocationSearchResultsProps = {
  locationSearchActorRef: LocationSearchService; // prettier-ignore
  interactedLocationRestaurantSlug: string | undefined;
  interactedLocationDeliveryAddressId: string | undefined;
  withSafeAreaInsets?: boolean;
  onExpandedChange?: (isExpanded: boolean) => void;
};
